module.exports = __webpack_public_path__ + "img/logo.60b7a1db.png";